// extracted by mini-css-extract-plugin
export default {"projectJoinItem":"styles_project-join-item_HUI3m"};